import { render } from "./PartialTitle.vue?vue&type=template&id=7dd676ee"
import script from "./PartialTitle.vue?vue&type=script&lang=js"
export * from "./PartialTitle.vue?vue&type=script&lang=js"

import "./PartialTitle.vue?vue&type=style&index=0&id=7dd676ee&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__